const DEFAULT_MS_CLIENT_ID = "883e95b3-1c56-4fd6-a2a0-3355bc7ca9dc";

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_MS_CLIENT_ID || DEFAULT_MS_CLIENT_ID,
        authority: "https://login.microsoftonline.com/common",
        redirectUri: "/authorised.html",
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ["User.Read"],
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com",
};
